module.exports = __webpack_public_path__ + "img/20190618162157QQ截图20190617164806.8adcd1f6.png";